module.exports = __webpack_public_path__ + "static/img/li6_2.85f40d85.png";